import { useState } from 'react'

import { YearSelect } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { controls, numberSize, year } from '../Controls'

export function YearSelectUsage() {
  const [props, setProps] = useState(() =>
    controls()
      .add(numberSize('size'))
      .add(year('maxValue', null))
      .add(year('minValue', null))
      .add(year('value', null))
  )

  function handleChange(nextYear) {
    setProps(controls => controls.setValue('value', nextYear))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={YearSelect}
        name='YearSelect'
        style={{ width: 240 }}
        onChange={handleChange}
      />
      <ComponentProps name='YearSelect' value={props} onChange={setProps} />
    </>
  )
}
